import _ from "lodash";
import { APIHelper } from "../Apis/APIHelper";
import { error, success, warning } from "../Components/custom-toast/CustomToast";
import { t } from "i18next";
import * as Service from "../Services/service";
import { useEffect } from "react";
import { LogOut } from "./customer-service";
import { useNavigate } from "react-router-dom";



export const loadInit = async (setObjectDto) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000019",
        "obj": {}
    }
    // //GW test
    const session = sessionStorage.getItem("sessionId") !== null && sessionStorage.getItem("sessionId") !== "undefined" && sessionStorage.getItem("sessionId") !== "" ? JSON.parse(sessionStorage.getItem("sessionId")) : null;
    const objSession = sessionStorage.getItem("objectDto") !== null && sessionStorage.getItem("objectDto") !== "" ? JSON.parse(sessionStorage.getItem("objectDto")) : { "checked": 0, "policyChecked": 0 };
    if (session === null || _.isEmpty(objSession)) {
        const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
        const data = await APIHelper.postDataCustomer(body, bearerToken);
        if (data !== undefined) {
            if (data.code === "1") {
                const jsonData = JSON.parse(data.jsonData);
                if (jsonData !== undefined && jsonData !== "undefined" && jsonData !== null && jsonData !== '') {
                    sessionStorage.setItem("sessionId", JSON.stringify(jsonData.sessionId));
                    sessionStorage.setItem("objectDto", JSON.stringify(jsonData));
                    if (jsonData.benIdDate !== undefined) jsonData.benIdDate = new Date(jsonData.benIdDate);
                    if (jsonData.admisionDateAdd !== undefined) jsonData.admisionDateAdd = new Date(jsonData.admisionDateAdd);
                    if (jsonData.admisionDateHi !== undefined) jsonData.admisionDateHi = new Date(jsonData.admisionDateHi);
                    if (jsonData.dischargeDateHi !== undefined) jsonData.dischargeDateHi = new Date(jsonData.dischargeDateHi);
                    setObjectDto(jsonData);
                } else {
                    return warning(t("erroraccesspage"))
                }
            } else {
                return error(t("erroraccesspage"));
            }
        } else {
            return setObjectDto(undefined);
        }
    } else {
        if (objSession.benIdDate !== undefined) objSession.benIdDate = new Date(objSession.benIdDate);
        if (objSession.admisionDateAdd !== undefined) objSession.admisionDateAdd = new Date(objSession.admisionDateAdd);
        if (objSession.admisionDateHi !== undefined) objSession.admisionDateHi = new Date(objSession.admisionDateHi);
        if (objSession.dischargeDateHi !== undefined) objSession.dischargeDateHi = new Date(objSession.dischargeDateHi);
        setObjectDto(objSession);
    }
}

export const ManageClaimRequest = (objectDto, setObjectDto) => {
    useEffect(() => {
        loadInit(setObjectDto);
    }, []);
    useEffect(() => {
        if (objectDto !== undefined && !_.isEmpty(objectDto)) {
            if (objectDto.sessionId === undefined && objectDto.checked !== undefined) {
                setObjectDto({ ...objectDto, sessionId: JSON.parse(sessionStorage.getItem("sessionId")) });
            } else {
                sessionStorage.setItem("objectDto", JSON.stringify(objectDto));
            }
        } else if (objectDto === undefined) {
            sessionStorage.setItem("objectDto", JSON.stringify({ "checked": 0, "policyChecked": 0 }));
            setObjectDto({ "checked": 0, "policyChecked": 0 })
        }
    }, [objectDto]);
}

export const deletePropertyObjectDto = (property, objectDto, setObjectDto) => {
    let copiedObjectDto = { ...objectDto };
    delete copiedObjectDto[property];
    setObjectDto(objectDto => ({
        ...copiedObjectDto
    }));
    // console.log(objectDto);
}

export const HandleSendSMSToken = async (id, phone, poNo, setObjectDto, setCounter) => {
    if (id !== "" && phone !== "" && poNo !== "") {
        const body = {
            "mesgId": "CUSTOMER_MESG_00000020",
            "obj": {
                policyNo: poNo,
                idNumber: id,
                poPhone: phone,
            }
        };
        const data = await APIHelper.postDataClaim(body);
        if (data !== 'ERR') {
            if (data.code === "1") {
                //trước mắt get data thôi
                const jsonData = JSON.parse(data.jsonData);
                sessionStorage.setItem("objectDto", JSON.stringify(jsonData));
                setObjectDto(jsonData);
                setCounter(600);
            } else {
                return error(t("erroraccesspage"));
            }
        }
    } else {
        warning("NHẬP DÔ");
    }
}

export const getListPolicyNumber = async (setListPo, setObjectDto) => {
    const objectDto = JSON.parse(localStorage.getItem('aaa'));
    const body = {
        mesgId: "CUSTOMER_MESG_00000004",
        obj: objectDto
    };
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data === 401) {
        warning("Thời gian kết nối tới máy chủ đã hết hạn! Vui lòng đăng nhập lại để tiếp tục!");
        return setListPo(401);
    }
    if (data !== 'ERR') {
        if (data.code === "1") {
            const jsonData = JSON.parse(data.jsonData);
            var list = [];
            if (jsonData.length === 0) return setListPo(list);
            jsonData.map((item) => {
                list.push(item.poNumber);
            })
            return setListPo(list);
        }
    } else {
        return warning("Không kết nối được tới server");
    }
    return alert("Lỗi hệ thống");
}

// Normal claim
// export const HandleVerifyToken = async (objectDto, token, setToken, setObjectDto, setLoading) => {
//     if (token !== "" && objectDto.poPhone !== "") {
//         const body = {
//             "mesgId": "CUSTOMER_MESG_00000022",
//             "obj": {
//                 phone: objectDto.poPhone,
//                 token: token,
//                 poNumber: objectDto.policyNo,
//                 poIdNumber: objectDto.idNumber,
//             }
//         };
//         const data = await APIHelper.postDataClaim(body);
//         console.log(data);
//         if (data !== 'ERR') {
//             if (data.code === "1") {
//                 const jsonData = JSON.parse(data.jsonData);
//                 if (jsonData.verifyOtp !== 0) {
//                     if (objectDto.verifyOtp >= 4) {
//                         alert("Bạn đã nhập sai OTP nhiều lần. Vui lòng kiểm tra hoặc nhấn Gửi lại OTP (lưu ý không quá 5 lần/ ngày).");
//                         setObjectDto({ ...objectDto, verifyOtp: 0, policyChecked: 0 });
//                         document.getElementById("otpDiv").style.display = "none";
//                         document.getElementById("policyDiv").style.display = "block";
//                         setToken('');
//                     } else {
//                         setObjectDto({ ...objectDto, verifyOtp: objectDto.verifyOtp + 1 });
//                         setToken('');
//                     }
//                 } else {
//                     setObjectDto(jsonData);
//                 }
//             }
//         }
//     } else {
//         warning("NHẬP DÔ");
//     }
//     setLoading(false);
// }

// Customer claim
export const HandleVerifyToken = async (poNumber, setObjectDto, setLoading) => {
    const idNumber = JSON.parse(localStorage.getItem('aaa')).poIdNumber;
    if (poNumber !== "") {
        const body = {
            "mesgId": "CUSTOMER_MESG_00000022",
            "obj": {
                phone: "1111111111",
                token: "123456",
                poNumber: poNumber,
                poIdNumber: idNumber,
            }
        };
        const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
        const data = await APIHelper.postDataCustomer(body, bearerToken);
        if (data !== 'ERR') {
            if (data.code === "1") {
                const jsonData = JSON.parse(data.jsonData);
                setObjectDto(jsonData);
            }
        }
    } else {
        warning("NHẬP DÔ");
    }
    setLoading(false);
}

export const validateValue = (value) => {
    if (value === undefined || value === "" || value === null) {
        return false; //value fail
    }
    return true;//value ok
}
export function HandleValidateStep(objectDto, setOpen) {
    if (objectDto.checked === 1) {
        //first step check mail + address
        if (!(validateValue(objectDto.email) && validateValue(objectDto.contactAddress) && Service.ValidateEmail(objectDto.email))) return false;
    } else if (objectDto.checked === 2) {
        if (!(validateValue(objectDto.laNumber))) return false;
    } else if (objectDto.checked === 3) {
        if (objectDto.addBenefitChecked === 0 && objectDto.hiBenefitChecked === 0) {
            warning("Vui lòng chọn quyền lợi bảo hiểm");
            return false;
        }
        if (objectDto.hiBenefitChecked === 1) {
            if (objectDto.rqDetailsDtoList === undefined || objectDto.rqDetailsDtoList.length === 0) {
                warning('Vui lòng "Thêm đợt điều trị"');
                return false;
            }
        }
        if (objectDto.addBenefitChecked === 1) {
            if (!(validateValue(objectDto.strBenefitDetailsIds) &&
                validateValue(objectDto.diagnosticAdd) &&
                validateValue(objectDto.admisionDateAdd) &&
                validateValue(objectDto.reasonAdd))) return false;
        }
    } else if (objectDto.checked === 4) {
        if (objectDto.paymentMethodChecked === 1) {
            if ((validateValue(objectDto.benName) === false || validateValue(objectDto.benIdNumber) === false || validateValue(objectDto.benIdDate) === false ||
                validateValue(objectDto.areaDesc) === false)) return false;
        } else if (objectDto.paymentMethodChecked === 2) {
            if (validateValue(objectDto.policyPayment) === false) return false;
        } else if (objectDto.paymentMethodChecked === 3) {
            if (!(validateValue(objectDto.bankName) && validateValue(objectDto.bankOffice)
                && validateValue(objectDto.bankOwner) && validateValue(objectDto.bankAccount))) return false;
        } else if (objectDto.paymentMethodChecked === 4) {
            if (!(validateValue(objectDto.benName) && validateValue(objectDto.benIdNumber)
                && validateValue(objectDto.benIdDate) && validateValue(objectDto.bankName) && validateValue(objectDto.bankOffice))) return false;
        }
    } else if (objectDto.checked === 5) {
        if (!(validateValue(objectDto.yesChecked))) {
            warning('Vui lòng chọn "THÔNG TIN BẢO HIỂM KHÁC"');
            return false;
        }
        if (objectDto.yesChecked === 1) {
            if (objectDto.otherList === undefined || objectDto.otherList.length === 0) {
                warning('Vui lòng "Thêm công ty khác"')
                return false;
            }
        }
        if (objectDto.checkSumAssured !== 0) {
            console.log('aaaa');
            setOpen(true);
            return false;
        }
    }
    return true;
}

export const HandleNextStep = async (objectDto, setObjectDto, setLoading, setValidate, setOpen) => {
    if (HandleValidateStep(objectDto, setOpen)) {
        setValidate(false);
        const body = {
            "mesgId": "CUSTOMER_MESG_00000023",
            "obj": objectDto
        };
        const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
        const data = await APIHelper.postDataCustomer(body, bearerToken);
        if (data !== 'ERR') {
            if (data.code === "1") {
                const jsonData = JSON.parse(data.jsonData);
                if (jsonData.benIdDate !== undefined) jsonData.benIdDate = new Date(jsonData.benIdDate);
                if (jsonData.admisionDateAdd !== undefined) jsonData.admisionDateAdd = new Date(jsonData.admisionDateAdd);
                if (jsonData.admisionDateHi !== undefined) jsonData.admisionDateHi = new Date(jsonData.admisionDateHi);
                if (jsonData.dischargeDateHi !== undefined) jsonData.dischargeDateHi = new Date(jsonData.dischargeDateHi);
                setObjectDto(jsonData);
            } else {
                warning("ERROR API");
            }
        } else {
            warning("ERROR 500");
        }
    } else {
        setValidate(true);
    }
    setLoading(false);
}

export const HandlePreviousStep = async (objectDto, setObjectDto, setLoading, setValidate) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000024",
        "obj": objectDto
    };
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data !== 'ERR') {
        if (data.code === "1") {
            const jsonData = JSON.parse(data.jsonData);
            if (jsonData.benIdDate !== undefined) jsonData.benIdDate = new Date(jsonData.benIdDate);
            if (jsonData.admisionDateAdd !== undefined) jsonData.admisionDateAdd = new Date(jsonData.admisionDateAdd);
            if (jsonData.admisionDateHi !== undefined) jsonData.admisionDateHi = new Date(jsonData.admisionDateHi);
            if (jsonData.dischargeDateHi !== undefined) jsonData.dischargeDateHi = new Date(jsonData.dischargeDateHi);
            setObjectDto(jsonData);
            // if (jsonData.checked === 1 || jsonData.checked === 2 || jsonData.checked === 4 || jsonData.checked === 5) {
            //     setObjectDto({ ...objectDto, checked: jsonData.checked });
            // } else if (jsonData.checked === 3) {
            //     setObjectDto({ ...objectDto, checkSumAssured: 1, checked: 3, strMsgAdd: null });
            // } else if (jsonData.checked === 0) {
            //     setObjectDto(jsonData);
            // }
        } else {
            warning("ERROR API");
        }
    } else {
        warning("ERROR 500");
    }
    setValidate(false);
    setLoading(false);
}

export const HandleSelectLifeInsurred = async (objectDto, setObjectDto, setLoading) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000026",
        "obj": objectDto
    }
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data !== 'ERR') {
        if (data.code === "1") {
            const jsonData = JSON.parse(data.jsonData);
            if (jsonData.benIdDate !== undefined) jsonData.benIdDate = new Date(jsonData.benIdDate);
            if (jsonData.admisionDateAdd !== undefined) jsonData.admisionDateAdd = new Date(jsonData.admisionDateAdd);
            if (jsonData.admisionDateHi !== undefined) jsonData.admisionDateHi = new Date(jsonData.admisionDateHi);
            if (jsonData.dischargeDateHi !== undefined) jsonData.dischargeDateHi = new Date(jsonData.dischargeDateHi);
            setObjectDto(jsonData);
        } else {
            warning("ERROR API");
        }
    } else {
        warning("ERROR 500");
    }
    setLoading(false);
}

export const HandleAddBenefitDetails = async (objectDto, setObjectDto) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000027",
        "obj": objectDto
    }
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data !== 'ERR') {
        // console.log(data);
        if (data.code === "1") {
            const jsonData = JSON.parse(data.jsonData);
            if (jsonData.benIdDate !== undefined) jsonData.benIdDate = new Date(jsonData.benIdDate);
            if (jsonData.admisionDateAdd !== undefined) jsonData.admisionDateAdd = new Date(jsonData.admisionDateAdd);
            if (jsonData.admisionDateHi !== undefined) jsonData.admisionDateHi = null;
            if (jsonData.dischargeDateHi !== undefined) jsonData.dischargeDateHi = null;
            if (jsonData.diagnosticHi !== undefined) jsonData.diagnosticHi = null;
            if (jsonData.strHospitalHi !== undefined) jsonData.strHospitalHi = null;
            setObjectDto(jsonData);
        } else {
            warning("ERROR API");
        }
    } else {
        warning("ERROR 500");
    }
}

export const ConvertDateJS = (convertDate) => { // new Date() (in Reactjs)
    var date = new Date(convertDate.$d);
    const result = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    return result;
}

export function ConvertDate(str) { //date() (in html && spring)
    var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join("-");
}




export const HandleAddTreatment = async (objectDto, setObjectDto) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000028",
        "obj": objectDto
    }
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data !== 'ERR') {
        if (data.code === "1") {
            const jsonData = JSON.parse(data.jsonData);
            // setObjectDto(jsonData);
            setObjectDto({ ...objectDto, admisionDateHi: null, dischargeDateHi: null, diagnosticHi: null, strHospitalHi: null, rqDetailsDtoList: jsonData.rqDetailsDtoList });
        } else {
            warning("ERROR API");
        }
    } else {
        warning("ERROR 500");
    }
}

export function getStrBenefitDetail(objectDto) {
    if (objectDto.strBenefitDetailsIds !== undefined) {
        var list = objectDto.strBenefitDetailsIds.split(',');
        var detail = [];
        if (objectDto.addSelectionList !== undefined && objectDto.strBenefitDetailsIds !== undefined && objectDto.strBenefitDetailsIds !== "") {
            objectDto.addSelectionList.map((item) => {
                list.map((itemList) => {
                    if (item.id.toString() === itemList) {
                        detail.push(item.benefitDetails);
                    }
                })
            })
        }
        return detail;
    }
    return null;
}

export function setStrBenefitDetailsIds(objectDto, setObjectDto, strBenefitDetails) {
    var temp = [];
    strBenefitDetails.map((itemStr) => {
        objectDto.addSelectionList.map((item) => {
            if (_.isEqual(item.benefitDetails, itemStr)) {
                temp.push(item.id);
            }
        })
    });
    temp.sort((a, b) => (a > b) ? 1 : -1)
    var a = '';
    temp.map((item) => {
        if (a === '') a = item.toString();
        else a = a + ',' + item.toString();
    })
    setObjectDto({ ...objectDto, strBenefitDetailsIds: a });
}

export const HandleGetPaymentMethodDetails = async (objectDto, setObjectDto) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000034",
        "obj": objectDto
    }
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data !== 'ERR') {
        // console.log(data);
        if (data.code === "1") {
            const jsonData = JSON.parse(data.jsonData);
            console.log("DATA API:")
            console.log(jsonData);
            // setObjectDto(jsonData);
            setObjectDto({ ...objectDto, csOfficeList: jsonData.csOfficeList })
        } else {
            warning("ERROR API");
        }
    } else {
        warning("ERROR 500");
    }
}

export const HandleAddCompany = async (objectDto, setObjectDto, setLoading) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000030",
        "obj": objectDto
    };
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data !== 'ERR') {
        if (data.code === "1") {
            const jsonData = JSON.parse(data.jsonData);
            console.log(jsonData);
            const otherList = jsonData.otherList;
            otherList.map((item) => {
                item.effectiveDate = new Date(item.effectiveDate);
            })
            setObjectDto({ ...objectDto, otherList: otherList, sumAssured: null, effectiveDate: null, companyName: null });
        } else {
            warning("ERROR API");
        }
    } else {
        warning("ERROR 500");
    }
    setLoading(false);
}

export const currencyFormat = (num) => {
    return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}

export const RemoveTreatment = async (objectDto, setObjectDto, index) => {
    var list = [];
    list = objectDto.rqDetailsDtoList;
    list.splice(index, 1);
    setObjectDto({ ...objectDto, rqDetailsDtoList: list });
}

export const RemoveCompany = async (objectDto, setObjectDto, index) => {
    var list = [];
    list = objectDto.otherList;
    list.splice(index, 1);
    setObjectDto({ ...objectDto, otherList: list });
}

const base64Img = (img) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.onerror = reject;
    });
};

export const HandleAddFile = (e, listFile, setListFile, setLoading, type, objectDto, setObjectDto) => {
    const list = listFile;
    const files = e.target.files;
    var check = true;
    const sessionId = JSON.parse(sessionStorage.getItem("sessionId"));
    Array.from(files).forEach(file => {
        base64Img(file).then((value) => {
            const time = Date.now().toString();
            const dataPush = {
                base64: value,
                documentCode: type === 1 ? "001" : type === 2 ? "002" : type === 5 ? "005" : type === 6 ? "006" : "003",
                fileName: time + "_" + Service.toNonAccentVietnamese(file.name),
                timestamp: time,
                fileId: "",
                id: "",
                mesgData: "",
                status: "",
                system: "",
                sessionId: sessionId,
            };
            list.push(dataPush);
        }).finally(() => {
            setListFile(list);
            setObjectDto({ ...objectDto, fileList: listFile })
            sessionStorage.setItem('objectDto', JSON.stringify(objectDto)); //setObject
            count = count + 1;
        }).catch(() => check = false);
    })
    if (check)
        success(files.length + t("messagesuccessuploadimage"));
    else
        error("Tải hình ảnh không thành công!!!");
    setLoading(false);
}

export function HandleDeleteFile(listFile, setListFile, index, objectDto, setObjectDto) {
    var datalist = [];
    listFile.map((item) => {
        if (listFile.indexOf(item) !== index) datalist.push(item);
        return datalist;
    });
    setObjectDto({ ...objectDto, fileList: datalist });
    return setListFile(datalist);
}


export const onTermChange = (e, setTerm, setObjectDto, objectDto) => {
    setTerm(e.target.checked);
    setObjectDto({ ...objectDto, termChecked: e.target.checked === true ? 1 : 0 })
}

export const HandleUploadImage = async (objectDto) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000037",
        "obj": objectDto
    }
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data !== 'ERR') {
        if (data.code === "1" && data.message === "1") {
            return 1;
        } else {
            warning("ERROR API");
        }
    } else {
        warning("ERROR 500");
    }
}

export const SubmitRequest = async (objectDto, setObjectDto) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000035",
        "obj": objectDto
    };
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    console.log(data);
    if (data.code === "1") {
        const jsonData = JSON.parse(data.jsonData);
        console.log(jsonData);
        if (jsonData === "ERR") {
            // console.log("ERROR at SubmitRequest");
            return "ERR"
        } else {
            const jsonData = JSON.parse(data.jsonData);
            if (jsonData.benIdDate !== undefined) jsonData.benIdDate = new Date(jsonData.benIdDate);
            if (jsonData.admisionDateAdd !== undefined) jsonData.admisionDateAdd = new Date(jsonData.admisionDateAdd);
            if (jsonData.admisionDateHi !== undefined) jsonData.admisionDateHi = null;
            if (jsonData.dischargeDateHi !== undefined) jsonData.dischargeDateHi = null;
            if (jsonData.diagnosticHi !== undefined) jsonData.diagnosticHi = null;
            if (jsonData.strHospitalHi !== undefined) jsonData.strHospitalHi = null;
            setObjectDto(jsonData);
            success("Gửi yêu cầu thành công");
        }
    } else {
        error(t("erroraccesspage"))
    }
}

export const HandleValidateSubmit = (objectDto) => {
    if (objectDto.checked === 6) {
        if (objectDto.fileList === undefined || objectDto.fileList.length === 0) return false;
        else {
            var doc1 = false;
            var doc2 = false;
            var doc3 = false;
            objectDto.fileList.map((item) => {
                if (item.documentCode === "001") doc1 = true;
                if (item.documentCode === "005") doc2 = true;
                if (item.documentCode === "006") doc3 = true;
            })
            if (objectDto.hiBenefitChecked === 1 && doc1 === false) return false;
            if (objectDto.addBenefitChecked === 1 && (doc2 === false || doc3 === false)) return false;
        }
    }
    return true;
}

export const HandleSubmitRequest = async (objectDto, setObjectDto, listFile, setLoading, setValidate) => {
    setLoading(true);
    if (HandleValidateSubmit(objectDto)) {
        document.body.style.overflow = 'hidden';
        var files = [];
        // const sessionId = JSON.parse(sessionStorage.getItem("sessionId"));
        // setObjectDto({ ...objectDto, sessionId: sessionId.toString() });
        if (listFile.length !== 0) {
            listFile.map(item => {
                const dataPush = {
                    base64: item.base64.split("base64,").pop(),
                    documentCode: item.documentCode,
                    fileName: item.fileName,
                    timestamp: item.timestamp,
                    field: null,
                    id: null,
                    mesgData: null,
                    status: null,
                    system: null,
                    // sessionId: sessionId,
                };
                files.push(dataPush);
            });
        }
        objectDto.fileList = files;
        // if (validateSubmit(objectDto, files, setValidate)) {
        const upload = await HandleUploadImage(objectDto);
        if (upload === 'ERR') {
            error(t("errormessageserver"));
        } else if (upload === 0) {
            error(t("errormessageloadimagefail"));
        } else if (upload === 1) {
            await SubmitRequest(objectDto, setObjectDto);
        }
        window.scrollTo(0, document.body.scrollHeight);
        // }
        document.body.style.overflow = 'auto';
    } else {
        setValidate(true);
        warning(t("errormessagerequirefield"));
    }
    setLoading(false);
}

export const HandleSubmitRequestNoUpload = async (objectDto, setObjectDto, setLoading, setValidate) => {
    setLoading(true);
    if (HandleValidateSubmit(objectDto)) {
        document.body.style.overflow = 'hidden';
        var files = [];
        objectDto.fileList = files;
        await SubmitRequest(objectDto, setObjectDto);
        window.scrollTo(0, document.body.scrollHeight);
        document.body.style.overflow = 'auto';
    } else {
        setValidate(true);
        warning(t("errormessagerequirefield"));
    }
    setLoading(false);
}

export const HandlePrintPDF = async (objectDto) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000039",
        "obj": objectDto
    }
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    console.log(data);
    if (data !== 'ERR') {
        if (data.code === "1" && data.message === "1") {
            return { "code": "1", "data": data.objData };
        } else {
            warning("ERROR API");
            return { "code": "0" };
        }
    } else {
        warning("ERROR 500");
        return { "code": "ERR" }
    }
}

export const HandleViewPDF = async (objectDto) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000040",
        "obj": objectDto
    };
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    console.log(data);
    if (data.code === "1") {
        const jsonData = JSON.parse(data.jsonData);
        console.log(jsonData);
        if (jsonData === "ERR") {
            return "ERR"
        } else {
            const jsonData = JSON.parse(data.jsonData);
            return Service.handleOpenPDF(jsonData);
        }
    } else {
        error(t("erroraccesspage"))
    }
}

export const HandleShowPDF = async (objectDto, setLoading) => {
    document.body.style.overflow = 'hidden';
    // if (validateSubmit(objectDto, files, setValidate)) {
    const printPDF = await HandlePrintPDF(objectDto);
    if (printPDF.code === 'ERR') {
        error(t("errormessageserver"));
    } else if (printPDF.code === "0") {
        error("Lỗi không xem được đơn yêu cầu GQQL");
    } else if (printPDF.code === "1") {
        await HandleViewPDF(printPDF.data);
    }
    window.scrollTo(0, document.body.scrollHeight);
    // }
    setLoading(false);
    document.body.style.overflow = 'auto';
}

export const HandleClose = async (objectDto, setObjectDto) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000038",
        "obj": objectDto
    }
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data.code === "1") {
        sessionStorage.removeItem("sessionId");
        sessionStorage.removeItem("objectDto");
        loadInit(setObjectDto);
        window.scrollTo(0, 0);
        const navigator = useNavigate();
        navigator('/giai-quyet-quyen-loi');
    } else {
        error(t("erroraccesspage"))
    }
}

